<template>
  <div class="padding-sm">
    <div class="bg-white video_content">
      <div class="text-center">
        <template v-if="videoUrl">
          <video
            :src="videoUrl"
            crossorigin
            preload="auto"
            controls="true"
            style="width: 80%;height: 200px"
            controlslist="nodownload"
            @loadeddata="createPreImg($event)"
          ></video>
          <div class="btn-rerecording" @click="handleDelete">
            <van-icon name="delete-o" size="14" color="#ee0a24" />删除
          </div>
        </template>
        <van-uploader
          v-show="!videoUrl"
          v-model="video"
          accept="video/*"
          :max-count="1"
          ref="upload"
          :max-size="15 * 1024 * 1024"
          @oversize="onOversize"
          :after-read="videoRead"
        >
          <van-button class="uploadButton">上传视频</van-button>
        </van-uploader>
      </div>
    </div>
    <div class="tips">支持mp4,mov,m4v格式。最大不可超过15MB</div>
    <div class="bg-white" v-if="videoUrl">
      <UploadImg
        class="module"
        @uploadimg="uploadimg"
        title="视频封面图"
        :imgAmount="1"
        :imgArr="videoCoverArr"
      ></UploadImg>
    </div>
    <div class="text-center margin-tb">
      <van-button type="primary" size="large" @click="submit">保存</van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UploadImg from "@/views/clerk/UploadImg";

import {
  Button,
  Toast,
  Dialog,
  Field,
  Icon,
  Uploader,
  CellGroup,
  Cell
} from "vant";
import { updateVideo, getClerk } from "@/api/clerk/clerk";
import { uploadFile } from "@/api/cos";

Vue.use(Button)
  .use(Toast)
  .use(Dialog)
  .use(Field)
  .use(Icon)
  .use(Uploader)
  .use(CellGroup)
  .use(Cell);

export default {
  name: "UploadVideo",
  components: {
    UploadImg
  },
  data() {
    return {
      autoHeight: { minHeight: 100 },
      videoUrl: null,
      video: [],
      videoCoverArr: []
    };
  },
  mounted() {
    this.getClerkInfo();
  },
  methods: {
    async getClerkInfo() {
      Toast.loading("加载中");
      const { data: res } = await getClerk();
      Toast.clear();
      if (res.code == 0) {
        if (res.clerk.videoCover) {
          this.videoCoverArr = [res.clerk.videoCover];
        }
        if (res.clerk.videoUrl) {
          this.videoUrl = res.clerk.videoUrl;
          this.video = [res.clerk.videoUrl];
        }
      } else {
        Dialog.alert({
          title: "加载失败",
          message: res.msg
        });
      }
    },
    handleDelete() {
      this.videoUrl = null;
      this.video = [];
      this.videoCoverArr = [];
    },
    videoRead(file) {
      Toast.loading("加载中");
      console.log("file.file", file);
      uploadFile(this.$store.state.shop.id, "clerk/video", file.file)
        .then(url => {
          Toast.clear();
          this.videoUrl = url;
        })
        .catch(err => {
          Dialog.alert({
            title: "上传失败",
            message: err
          });
          this.videoUrl = null;
          this.video = [];
        })
        .finally(() => {
          Toast.clear();
        });
    },
    onOversize() {
      Toast("文件大小不能超过15M");
    },
    uploadimg(imgarr) {
      this.videoCoverArr = imgarr;
    },

    createPreImg(event) {
      this.$nextTick(() => {
        const videoEle = event.target;

        videoEle.currentTime = 0;
        const handleCanPlay = () => {
          // 创建 canvas
          const canvas = document.createElement("canvas");
          const scale = 0.8; // 压缩比例
          canvas.width = videoEle.videoWidth * scale;
          canvas.height = videoEle.videoHeight * scale;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(videoEle, 0, 0, canvas.width, canvas.height);

          // 将 canvas 转为 Blob（异步）
          canvas.toBlob(blob => {
            // 将 Blob 转换为 File 对象
            const file = new File([blob], "videoCover.png", {
              type: "image/png"
            });

            // 文件上传
            Toast.loading("加载中...");
            uploadFile(this.$store.state.shop.id, "clerk/video", file)
              .then(url => {
                console.log("url", url);
                Toast.clear();
                this.videoCoverArr = [{ url: url }];
              })
              .catch(err => {
                Toast.clear();
                Dialog.alert({
                  title: "上传失败",
                  message: err
                });
                this.videoCoverArr = [];
              })
              .finally(() => {
                Toast.clear();
                videoEle.removeEventListener("canplay", handleCanPlay); // 清理监听器
              });
          }, "image/png"); // 指定返回的文件类型
        };

        // 添加事件监听器
        videoEle.addEventListener("canplay", handleCanPlay);
      });
    },
    submit() {
      if (this.videoUrl && this.videoCoverArr.length === 0) {
        Dialog.alert({
          title: "保存失败",
          message: "请上传视频封面图"
        });
        return false;
      }
      Toast.loading({
        mask: true,
        message: "请稍候..."
      });
      let videoUrl = {
        url: this.videoUrl
      };
      if (!this.videoUrl) {
        videoUrl = null;
      }
      updateVideo(videoUrl, this.videoCoverArr[0]).then(res => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          this.video = [];
          Dialog.alert({
            title: "保存成功"
          });
          this.$router.back();
        } else {
          Dialog.alert({
            title: "保存失败",
            message: data.msg
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.video_content {
  padding-bottom: 10px;
}
.returnClose {
  font-size: 16px;
  color: darkgrey;
}
.tips {
  margin: 10px 0;
}

.addButton {
  //width: 100%;
  //height: 35px;
  //border-radius: 30px;
  background: #04ade0;
  font-size: 15px;
  color: white;
  border: none;
}

.contentField {
  font-size: 16px;
  border: 1px solid #efefef;
}

.uploadButton {
  display: inline-block;
  line-height: 44px;
  min-width: 92px;
  margin: 30px;
  height: 44px;
  font-size: 15px;
  background: #04ade0;
  color: white;
  white-space: nowrap;
}

.record-status {
  text-align: center;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 92px;
    height: 100%;
    overflow: hidden;
    cursor: pointer;
    opacity: 0;
    z-index: 3;
  }
}
.btn-rerecording {
  display: flex;
  width: 100%;
  color: #ee0a24;
  height: 20px;
  line-height: 20px;
  margin: 10px 0;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  .van-icon {
    margin-right: 3px;
  }
}

/deep/ .van-cell:after {
  border: none;
}
</style>
